import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { data, exec, isLoading, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_MOULD_RESUME',
    manual: true,
  });

  useEffect(() => {
    // if (params.mould_ids !== '' && params.start !== '' && params.end !== '') {
    if (params.start !== '' && params.end !== '') {
      let url = `/api/mould/use/record`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) url += '?';
        else url += '&';
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [data || [], isLoading, isRequestSuccessed];
});
